export default {
  path: '/credit_transfers',
  name: 'credit_transfers',
  component: () => import('../components/credittransfer/Layout'),
  redirect: { name: 'CreditTransferList' },
  children: [
    {
      name: 'CreditTransferList',
      path: '',
      component: () => import('../views/credittransfer/List')
    },
    {
      name: 'CreditTransferCreate',
      path: 'new',
      component: () => import('../views/credittransfer/Create')
    },
    {
      name: 'CreditTransferUpdate',
      path: ':id/edit',
      component: () => import('../views/credittransfer/Update')
    },
    {
      name: 'CreditTransferShow',
      path: ':id',
      component: () => import('../views/credittransfer/Show')
    }
  ]
};
